import request from "@/utils/request";

// 查询菜单列表
export function findResourceById(query) {
  return request({
    url: "/cloudResource/findResourceById",
    method: "post",
    headers: {
      isToken: true,
    },
    data: { ...query, platformCode: "xspjxt", resourceId: 1 },
  });
}
